module.exports = __webpack_public_path__ + "static/media/video-product.dc7c2dad.jpg";